import withAuthentication from './withAuthentication';

export default withAuthentication;
